import React, { useState, useEffect, useMemo  } from 'react';
import './UpdateUsersPage.css';
import { Button, Text, Grid, Col, Title, TextInput, Dropdown, DropdownItem, Card } from "@tremor/react";
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import { User } from '../../interfaces/AccessInterfaces';
import SidebarComponent from '../../components/SidebarComponent';
import TitleComponent from "../../components/TitleComponent";
import { validateCPF } from '../../utils/validaCpf';
import { Prices } from '../../interfaces/FinanceInterface';

export default function UpdateUsersPage() {
  const [cookies] = useCookies(['mazelog-user']);
  const token = cookies['mazelog-user']?.token_data?.access_token;
  const orgId = cookies["mazelog-user"]?.organization_data?.id_org;
  const oauth = "Bearer " + token;
  const baseURLAuth = process.env.REACT_APP_MAZELOG_AUTH_BASE_URL;
  const baseURL = process.env.REACT_APP_MAZELOG_SYSTEM_BASE_URL;

  const nameUser = cookies["mazelog-user"]?.organization_data?.name;
  const userProfile = cookies['mazelog-user']?.user_data?.user_profile;
  const isTransporter = userProfile === "TRANSPORTER" || userProfile === "TRANSPORTER_COLLECTER";
  const profileSelected = new URLSearchParams(window.location.search).get('profile');
  const isEditingClient = profileSelected === "CLIENT";
  
  let { id } = useParams();
  const navigate = useNavigate();

  const [requestProcessing, setRequestProcessing] = useState(false);
  const [user, setUser] = useState<User>();
  const [cpfError, setCpfError] = useState<string | null>(null);
  const [priceUser, setPriceUser] = useState("");
  const [prices, setPrices] = useState<Prices[]>([]);


  const hasPriceTable = useMemo(()=> {
      return user?.user_profile === "CLIENT" || user?.user_profile === "TRANSPORTER" || user?.user_profile === "TRANSPORTER_COLLECTER"
  }, [user]) 

  const getUserData = () => {
    if (isTransporter && isEditingClient) {
        axios.get(`${baseURLAuth}/transporters/transporter_allocation/users?transporter=${nameUser}`,
          {headers: {
            "Content-Type": "application/json",
            "Authorization": oauth,
          }})
      .then((res) => {
          const client = res.data.find((u: User) => u.id_user !== undefined && u.id_user.toString() === id);
          if (client) {
            setUser(client);
          }
        })
        .catch((err)=>{
          alert('Erro!');
          navigate('/access')
        });
    } else {

      axios.get(`${baseURLAuth}/users/${id}`,
          {headers: {
            "Content-Type": "application/json",
            "Authorization": oauth,
          }})
      .then((res) => {
          setUser(res.data)
        })
        .catch((err)=>{
          alert('Erro!');
          navigate('/access')
        });
    }

  }

  const getUserPrice = () => {
    axios.get(`${baseURL}/prices/user/?user_id=${id}`, { headers: { accept: "application/json", Authorization: oauth } })
    .then((res) => {
      if (res.data != null) {
        setPriceUser(res.data.results[0].id_price);
      }
    })
    .catch((err) => console.log(err));
  }

  const handleGetPrices = () => {
    const oauth = "Bearer " + token;
    axios
      .get(`${baseURL}/prices/?org_id=${orgId}`, { headers: { accept: "application/json", Authorization: oauth } })
      .then((res) => {
        if (res.data != null) {
          setPrices(res.data.results);
        }
      })
      .catch((err) => console.log(err));
  };

  const updateUser = async () => {
    try {
      setRequestProcessing(true);

      if (!(isTransporter && isEditingClient)) {

        // Limpar formatação do telefone antes de enviar
        const userClean = { ...user };
        userClean.phone = userClean.phone?.replace(/[^\d]/g, ''); // Remove formatação do telefone
        
        // Atualizar usuário
        await axios.put(`${baseURLAuth}/users/${id}`, userClean, {
          headers: {
            "Content-Type": "application/json",
            "Authorization": oauth,
          },
        });
        
        alert("Usuário atualizado com sucesso!");
      }
  
      // Criar relacionamento entre usuário e preço
      if (priceUser) {
        const body = {
          id_user: id,
          id_price: priceUser,
        };
    
        await axios.post(`${baseURL}/prices/user/`, body, {
          headers: {
            accept: "application/json",
            Authorization: oauth,
          },
        });
      }
  
      navigate('/access');
  
    } catch (error) {
      console.error("Erro na atualização do usuário:", error);
      alert("Erro ao atualizar o usuário. Verifique os dados e tente novamente.");
    } finally {
      setRequestProcessing(false);
    }
  };
  

  const loadContent = async () => {
    await getUserData();
    await handleGetPrices();
    await getUserPrice();
  }

  useEffect( ()=>{
    loadContent()
  },[]) 

  const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const phoneValue = e.target.value.replace(/\D/g, ''); // Remove tudo que não for número
    let maskedPhone = '';

    if (phoneValue.length > 10) {
      // Com código de país (exemplo: 55 11 96467-7742)
      maskedPhone = phoneValue.replace(/^(\d{2})(\d{2})(\d{4,5})(\d{4})$/, '($1) $2 $3-$4');
    } else {
      // Sem código de país (exemplo: 11 96467-7742)
      maskedPhone = phoneValue.replace(/^(\d{2})(\d{4,5})(\d{4})$/, '($1) $2-$3');
    }

    setUser({ ...user!, phone: maskedPhone });
  };

  const handleCpfChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const cpf = e.target.value.replace(/\D/g, '');
    setUser({ ...user!, cpf });
    setCpfError(validateCPF(cpf) ? null : 'CPF inválido.');
  };

  return (
    <main className="Page">
      <SidebarComponent />
      <div className="Content">
        <TitleComponent />
        <div className="CreateUserViews">
            <Card>
                <Title>Atualizar usuário</Title>
                {!user ? "" :
                <Grid numCols={1} className="gap-2">
                    <Col numColSpan={1}>
                        <Text>ID Organização</Text>
                        <TextInput 
                        disabled={isTransporter && isEditingClient}
                        className='max-w-md'
                        onChange={(e) => {setUser({...user, id_org: parseInt(e.target.value)})}}
                        defaultValue={user.id_org.toString()}
                        />
                    </Col>
                    <Col numColSpan={1}>
                      <Text>Nome de usuário</Text>
                      <TextInput
                        disabled={isTransporter && isEditingClient}
                        className='max-w-md'
                        onChange={(e) => { setUser({ ...user, username: e.target.value }); }}
                        defaultValue={user.username}
                      />
                    </Col>
                    <Col numColSpan={1}>
                      <Text>Nome completo</Text>
                      <TextInput
                        disabled={isTransporter && isEditingClient}
                        className='max-w-md'
                        onChange={(e) => { setUser({ ...user, full_name: e.target.value }); }}
                        defaultValue={user.full_name}
                      />
                    </Col>
                    <Col numColSpan={1}>
                      <Text>Email</Text>
                      <TextInput
                        disabled={isTransporter && isEditingClient}
                        className='max-w-md'
                        onChange={(e) => { setUser({ ...user, email: e.target.value }); }}
                        defaultValue={user.email}
                      />
                    </Col>
                    <Col numColSpan={1}>
                      <Text>Senha (caso queira manter a mesma, deixar em branco)</Text>
                      <TextInput
                        disabled={isTransporter && isEditingClient}
                        className='max-w-md'
                        onChange={(e) => { setUser({ ...user, password: e.target.value }); }}
                      />
                    </Col>
                    <Col numColSpan={1}>
                      <Text>CPF</Text>
                      <TextInput
                        className='max-w-md'
                        value={user.cpf}
                        disabled={isTransporter && isEditingClient}
                        onChange={handleCpfChange}
                      />
                      {cpfError && <Text className="text-red-500">{cpfError}</Text>}
                    </Col>
                    <Col numColSpan={1}>
                      <Text>Telefone</Text>
                      <TextInput
                        className='max-w-md'
                        value={user.phone}
                        disabled={isTransporter && isEditingClient}
                        onChange={handlePhoneChange}
                      />
                    </Col>
                    <Col numColSpan={1}>
                      <Text>Permitir alterar usuario do evento</Text>
                      <input
                        type='checkbox'
                        className='mt-2'
                        disabled={isTransporter && isEditingClient}
                        checked={!!user.flag_alter_status_custom_user}
                        onChange={(e) => setUser({ ...user!, flag_alter_status_custom_user: e.target.checked })}
                      />
                    </Col>
                    <Col>
                        <Text>Perfil</Text>
                        <Dropdown
                        className='max-w-md'
                        defaultValue={user.user_profile}
                        disabled={isTransporter && isEditingClient}
                        onValueChange={ (value) => {setUser({...user,user_profile:value}); setPriceUser('')} }
                        >
                        <DropdownItem value="ADMIN" text="ADMIN" />
                        <DropdownItem value="EMPLOYEE" text="EMPLOYEE" />
                        <DropdownItem value="CLIENT" text="CLIENT" />
                        <DropdownItem value="TRANSPORTER" text="TRANSPORTER" />
                        <DropdownItem value="TRANSPORTER_COLLECTER" text="TRANSPORTER_COLLECTER" />
                        </Dropdown>
                    </Col>
                    { hasPriceTable && (
                      <Col>
                        <Text>Tabela de Preço</Text>
                        <Dropdown
                          className="max-w-md"
                          value={priceUser}
                          onValueChange={(value) => setPriceUser(value)}
                        >
                          {prices.map((item) => (
                            <DropdownItem key={item._id} value={item._id ?? "-"} text={item.title} />
                          ))}
                        </Dropdown>
                    </Col>
                    )}

                </Grid>}
            <Button
            disabled={requestProcessing}
            onClick={updateUser}
            className='CreateUserBtn'
            > Atualizar </Button>
            </Card>
        </div>
      </div>
    </main>
  );
}